(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["centralmedic-content"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cm-product-content')) {
  customElements.define('cm-product-content', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        this.observeTables();
        return;
      }
      this.ready = true;
      this.querySelectorAll('.new-list-grid').forEach(grid => {
        const cells = [...grid.children];
        const headers = cells.filter(cell => cell.classList.contains('list-tableheader'));
        const columns = headers.length;
        if (columns < 2 || cells.length <= columns || cells.length % columns !== 0) return;
        if (!cells.every((cell, index) => cell.classList.contains(index < columns ? 'list-tableheader' : 'list-tablecontent'))) return;
        grid.replaceWith(this.makeTable(cells.map(cell => [...cell.childNodes].map(node => node.cloneNode(true))), columns));
      });
      this.querySelectorAll('p').forEach(paragraph => {
        const lines = [[]];
        [...paragraph.childNodes].forEach(node => {
          if (node.nodeName === 'BR') lines.push([]);
          else lines[lines.length - 1].push(node.cloneNode(true));
        });
        const text = nodes => nodes.map(node => node.textContent).join('').trim();
        while (lines.length && !text(lines[0])) lines.shift();
        while (lines.length && !text(lines[lines.length - 1])) lines.pop();
        if (!lines.length) return;
        const hasHeading = text(lines[0]).toUpperCase() === 'ARTIKELINFORMATION';
        const headingNodes = hasHeading ? lines.shift() : null;
        if (hasHeading && !lines.length) {
          const heading = document.createElement('h2');
          heading.append(...headingNodes);
          paragraph.replaceWith(heading);
          return;
        }
        if (!/^(Nährwerte?|Inhalts?stoffe)$/.test(text(lines[0] || [])) || !/^Tagesportion/.test(text(lines[1] || [])) || !/^NRV\*/.test(text(lines[2] || []))) return;
        const columns = /^Höchstmenge\*/.test(text(lines[3] || [])) ? 4 : 3;
        if (this.dataset.productHandle === 'geko-ehemals-gelenk-komplex-plus' && columns === 4 && lines.length === 30) {
          const shortRows = lines.slice(4, 22);
          if (!shortRows.every((nodes, index) => index % 3 === 1 ? /^\d+mg$/.test(text(nodes)) : index % 3 === 2 ? text(nodes) === '-' : text(nodes).length > 10)) return;
          for (let row = 5; row >= 0; row--) lines.splice(4 + row * 3 + 3, 0, []);
        }
        if (lines.length <= columns || lines.length % columns !== 0) return;
        const replacement = document.createDocumentFragment();
        if (hasHeading) {
          const heading = document.createElement('h2');
          heading.append(...headingNodes);
          replacement.append(heading);
        }
        replacement.append(this.makeTable(lines, columns));
        paragraph.replaceWith(replacement);
      });
      this.querySelectorAll('h2').forEach(heading => {
        const previous = heading.previousElementSibling;
        if (previous?.tagName === 'H2' && previous.textContent.trim().toLowerCase() === heading.textContent.trim().toLowerCase()) heading.remove();
      });
      if (this.dataset.productHandle === 'frau-in-balance') {
        this.querySelectorAll('p').forEach(paragraph => {
          const text = paragraph.textContent.trim();
          if (text.startsWith('.tight p {') && text.endsWith('.tight li { margin: 0 0 2px 0; }')) paragraph.remove();
        });
      }
      this.querySelectorAll('table').forEach((table, index) => {
        if (table.closest('.cm-table-scroll')) return;
        const columns = table.rows[0]?.cells.length || 2;
        const block = document.createElement('div');
        block.className = 'cm-table-block';
        const hint = document.createElement('p');
        hint.className = 'cm-table-hint';
        hint.textContent = this.dataset.scrollHint;
        hint.id = `${this.closest('section').getAttribute('aria-labelledby')}-scroll-${index}`;
        hint.hidden = true;
        const region = document.createElement('div');
        region.className = 'cm-table-scroll';
        region.setAttribute('role', 'region');
        region.setAttribute('aria-label', `${this.dataset.tableLabel} ${index + 1}`);
        table.style.setProperty('--cm-table-min-width', `${columns === 2 ? 320 : columns === 3 ? 600 : 760}px`);
        table.before(block);
        block.append(hint, region);
        region.append(table);
      });
      this.observeTables();
    }
    makeTable(cells, columns) {
      const table = document.createElement('table');
      table.className = 'cm-nutrition-table';
      const head = table.createTHead();
      const body = table.createTBody();
      let row;
      cells.forEach((nodes, index) => {
        if (index % columns === 0) row = (index < columns ? head : body).insertRow();
        const header = index < columns || index % columns === 0;
        const cell = document.createElement(header ? 'th' : 'td');
        if (header) cell.scope = index < columns ? 'col' : 'row';
        cell.append(...nodes);
        row.append(cell);
      });
      return table;
    }
    observeTables() {
      this.observer?.disconnect();
      this.observer = new ResizeObserver(() => {
        this.querySelectorAll('.cm-table-scroll').forEach(region => {
          const overflow = region.scrollWidth > region.clientWidth + 1;
          const hint = region.previousElementSibling;
          hint.hidden = !overflow;
          if (overflow) {
            region.tabIndex = 0;
            region.setAttribute('aria-describedby', hint.id);
          } else {
            region.removeAttribute('tabindex');
            region.removeAttribute('aria-describedby');
          }
        });
      });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["centralmedic-header"] && !Shopify.designMode) return;
  try {
    
function initializeCentralmedicHeader(){
  document.querySelectorAll('[data-cm-header]').forEach(header=>{
    if(header.dataset.ready)return;
    header.dataset.ready='true';
    const toggle=header.querySelector('.cm-header__toggle');
    const nav=header.querySelector('.cm-navigation');
    const closeMenu=()=>{toggle.setAttribute('aria-expanded','false');toggle.setAttribute('aria-label','Menü öffnen');nav.classList.remove('cm-navigation--open')};
    toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));toggle.setAttribute('aria-label',open?'Menü schließen':'Menü öffnen');nav.classList.toggle('cm-navigation--open',open)});
    header.addEventListener('keydown',event=>{if(event.key==='Escape'){header.querySelectorAll('details[open]').forEach(d=>d.open=false);closeMenu()}});
    nav.addEventListener('click',event=>{if(event.target.closest('a'))closeMenu()});
    const products=header.querySelector('.cm-products');
    products.addEventListener('mouseenter',()=>{if(matchMedia('(min-width:990px) and (hover:hover)').matches)products.open=true});
    products.addEventListener('mouseleave',()=>{if(matchMedia('(min-width:990px) and (hover:hover)').matches)products.open=false});
    const updatePosition=()=>header.classList.toggle('cm-header--scrolled',window.scrollY>94);
    window.addEventListener('scroll',updatePosition,{passive:true});updatePosition();
    document.addEventListener('click',event=>{if(!header.contains(event.target)){header.querySelectorAll('details[open]').forEach(d=>d.open=false);closeMenu()}});
  });
}
initializeCentralmedicHeader();document.addEventListener('shopify:section:load',initializeCentralmedicHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["centralmedic-hero"] && !Shopify.designMode) return;
  try {
    
function initializeCentralmedicHero(){
  document.querySelectorAll('[data-cm-hero]').forEach(hero=>{
    if(hero.dataset.ready)return;hero.dataset.ready='true';
    const slides=[...hero.querySelectorAll('[data-cm-slide]')];const dots=[...hero.querySelectorAll('[data-cm-dot]')];const pause=hero.querySelector('[data-cm-pause]');
    let current=0,timer=null,paused=matchMedia('(prefers-reduced-motion:reduce)').matches;
    function stop(){clearInterval(timer);timer=null}
    function show(index){current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{const active=i===current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.querySelector('a').tabIndex=active?0:-1});dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===current)))}
    function play(){stop();if(!paused&&!document.hidden&&!hero.contains(document.activeElement))timer=setInterval(()=>show(current+1),Number(hero.dataset.interval)||6000)}
    function updateButton(){pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?'Slideshow abspielen':'Slideshow pausieren')}
    dots.forEach((dot,index)=>dot.addEventListener('click',()=>{show(index);play()}));
    pause.addEventListener('click',()=>{paused=!paused;updateButton();play()});
    hero.addEventListener('mouseenter',stop);hero.addEventListener('mouseleave',play);hero.addEventListener('focusin',stop);hero.addEventListener('focusout',()=>setTimeout(play,0));
    hero.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();show(current+(event.key==='ArrowRight'?1:-1));dots[current].focus()}});
    let startX=0;hero.addEventListener('touchstart',event=>{startX=event.changedTouches[0].clientX;stop()},{passive:true});hero.addEventListener('touchend',event=>{const delta=event.changedTouches[0].clientX-startX;if(Math.abs(delta)>50)show(current+(delta<0?1:-1));play()},{passive:true});
    document.addEventListener('visibilitychange',()=>document.hidden?stop():play());updateButton();play();
  });
}
initializeCentralmedicHero();document.addEventListener('shopify:section:load',initializeCentralmedicHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
